// extracted by mini-css-extract-plugin
module.exports = {"light":"Section_light__1Asfz","gray":"Section_gray__1ScGh","dark":"Section_dark__2GjRr","imgContainer":"Section_imgContainer__2Gst4"};